import { css, keyframes } from "@emotion/react";
import { IconButton } from "src/components/IconButton/IconButton.tsx";

export const RefreshButton = ({
  label,
  refreshing,
  onClick,
}: {
  label: string;
  refreshing: boolean;
  onClick: () => void;
}) => (
  <IconButton
    skin={"info"}
    size={"sm"}
    variant={"outlined"}
    aria-label={label}
    title={label}
    disabled={refreshing}
    onClick={onClick}
  >
    <i className={"icon-15-update"} css={refreshing && spinning} />
  </IconButton>
);

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const spinning = css`
  display: inline-block;
  animation: ${spin} 0.8s linear infinite;
`;
